module.exports = __webpack_public_path__ + "img/main-left-image.80a37265.jpg";